import type {
  AccessorialTypeOption,
  CurrencyOption,
  ShippingInstructionsCodeOption,
  RatingRateTypeOption,
  RatingUnitOption,
  CalculatePercentageOfOption,
  MovementTypeOption,
} from "../../hooks/react-query/backOffice/useAccessorialChargeForm";

// Updated to match API response (no 'code' field)
export const mockAccessorialTypeOptions: AccessorialTypeOption[] = [
  { id: 80, description: "Liftgate" },
  { id: 82, description: "Limited Access" },
  { id: 81, description: "Residential" },
];

export const mockMovementTypeOptions: MovementTypeOption[] = [
  { id: 45, description: "Both" },
  { id: 44, description: "Delivery" },
  { id: 43, description: "Pickup" },
];

export const mockCurrencyOptions: CurrencyOption[] = [
  { id: 1, description: "CAD" },
  { id: 2, description: "MXN" },
  { id: 3, description: "USD" },
];

export const mockShippingInstructionsCodeOptions: ShippingInstructionsCodeOption[] =
  [
    { id: 21, description: "Curbside/Dock Dlvry Only– No Ins Dlvry" },
    { id: 144, description: "Daylight Protect Coverage" },
    { id: 23, description: "Delivery Appointment" },
    { id: 138, description: "Delivery Appointment Not Required" },
    { id: 29, description: "Do Not Break Down Pallet" },
    { id: 31, description: "Do Not Double Stack" },
    { id: 34, description: "Fragile - Handle With Care" },
    { id: 146, description: "Grocery Warehouse Delivery" },
    { id: 145, description: "Grocery Warehouse Pickup" },
  ];

/** Rating Configuration → Rate Type (Add New Accessorial Charge). */
export const mockRatingRateTypeOptions: RatingRateTypeOption[] = [
  { id: 42, description: "Detention" },
  { id: 39, description: "Flat Rate" },
  { id: 41, description: "Percentage" },
  { id: 40, description: "Rate per Unit" },
];

export const mockRatingUnitOptions: RatingUnitOption[] = [
  { id: 122, description: "Lbs" },
];

export const mockCalculatePercentageOfOptions: CalculatePercentageOfOption[] = [
  { id: 121, description: "Freight Charges" },
  { id: 47, description: "Weight" },
];
